import React, { useEffect } from 'react';
import { Col, Container, Row } from 'reactstrap';
import OurLogo from '../c/OurLogo';
import ChangeArrow from '../c/ChangeArrow';
import XTab from '../c/XTab';
import { T } from '../traks';
import I18N from '../I18N';

import { Apify } from '../Apify';

const DefaultLeaderboard = Apify("/z/leaderboard")
	.with_query_from_props(props => ({key: props.data_key, type: "default"}))
	.with_refresh_interval(5*60) // refresh every 5 minutes
	.with_response_prop("data")
	.wrap((props) => {
        const { data } = props;
        const [tabIndex, setTabIndex] = React.useState(0)
        const [rows, setRows] = React.useState(data.Portfolios.length !== 0 ? data.Portfolios.map((p) => p) : []);

        const tabs = [<span><T>Value</T></span>, <span><T>Risk score</T></span>]
        
        useEffect(() => {
            let newRows;
            if (tabIndex === 0) {
                newRows = data.Portfolios.map((p) => p);
            } else if (tabIndex === 1) {
                newRows = data.BetaPortfolios.map((p) => p);
            }

            setRows(newRows);
        }, [tabIndex])

        const on_select = (i) => {
            setTabIndex(i);
        };


        let leaderboardClasses = 'leaderboard_ranking'

        if (data.CanUseBetaValues) {
            leaderboardClasses += ' leaderboard_tabs'
        }

        const getRows = () => {
            return rows.map((p) => {
                const key = p.Id;
                const percent_delta = ((p.Value - data.GameInitialAmount) / data.GameInitialAmount) * 100;
                const game_currency = data.GameCurrency;
                let place_icon = null;
                switch(p.Place) {
                    case 1:
                        place_icon = <img src='/gfx/medal-gold-0.svg' className="leaderboard_placement_icon" alt={'placement ' + p.Place} />;
                        break;
                    case 2:
                        place_icon = <img src='/gfx/medal-silver-0.svg' className="leaderboard_placement_icon" alt={'placement ' + p.Place} />;
                        break;
                    case 3:
                        place_icon = <img src='/gfx/medal-bronze-0.svg' className="leaderboard_placement_icon" alt={'placement ' + p.Place} />;
                        break;
                    default:
                        place_icon = <span className="leaderboard_placement_text pl-1">{p.Place}.</span>;
                }

                return (<tr key={key}>
                        <td></td>
                        <td className="ad_th_1px">{place_icon}</td>
                        <td>{p.OwnerScreenName}</td>
                        <td className="text-right">{p.TradesCount}</td>
                        <td className="text-right">{I18N.floatval_unit(p.Value, 2, game_currency)}</td>
                        <td className="text-right"><ChangeArrow pct={percent_delta} suffix="%"/></td>
                        {data.CanUseBetaValues && tabIndex === 1 && (
                            <td className="text-right">
                                {
                                    p.BetaValue !== 0 ?
                                        I18N.floatval_unit(p.BetaValue, 4) : I18N.floatval_unit(0, 4)
                                }
                            </td>
                        )}
                        {data.CanUseBetaValues && tabIndex === 1 && (
                            <td className="text-right">
                                {
                                    p.BetaValue !== 0 ?
                                        I18N.floatval_unit(percent_delta / p.BetaValue, 4) : I18N.floatval_unit(0, 4)
                                } %
                            </td>
                        )}
                    </tr>
                );
            });
        }
		return (
			<React.Fragment>
			<Container fluid className="leaderboard">
				<Container fluid className="leaderboard_top_container">
					<Row>
						<Col lg="6" className="pt-5">
							<OurLogo className="leaderboard_logo" />
						</Col>
						<Col lg="6" className="pt-3 text-right">
							<h1 className="pb-1"><T>Leaderboard</T></h1>
							<div className="leaderboard_game_name pb-4">{data.GameName}</div>
						</Col>
					</Row>
                    {data.CanUseBetaValues && (
                    <Row>
                        <Col>
                            <XTab row_classes={["pb-4", "no_unselected_border"]} add_classes={["white"]} selected={tabIndex} onSelect={on_select} tabs={tabs}/>
                        </Col>
                    </Row>
                    )}
				</Container>
			</Container>
            
				<Container fluid className={leaderboardClasses}>                 
					<Row className="pb-2">
						<Col>
							<table className="w-100">
								<thead className="text-capitalize">
									<tr>
										<th></th>
										<th></th>
										<th><T>NAME</T></th>
										<th className="text-right"><T>TRADES</T></th>
										<th className="text-right"><T>VALUE</T></th>
										<th className="text-right"><T>TOTAL CHANGE</T></th>
                                        {data.CanUseBetaValues && tabIndex === 1 && (
                                            <th className="text-right"><T>The risk score of the portfolio (Beta)</T></th>
                                        )}
                                        {data.CanUseBetaValues && tabIndex === 1 && (
                                            <th className="text-right"><T>The risk-adjusted return of the portfolio</T></th>
                                        )}
									</tr>
								</thead>
								<tbody>
									{getRows()}
								</tbody>
							</table>
						</Col>
					</Row>
				</Container>
			</React.Fragment>
		);
	});

export {
	DefaultLeaderboard,
};



// WEBPACK FOOTER //
// ./src/p/Leaderboard.js